export enum BookingDocTypes {
	client = 1000,
	candidate = 1001,
	both = 1002,
}
